import React, { useCallback, useEffect, useState } from "react";
import { Alert } from "reactstrap";

const APP_ALERT_EVENT = "app-alert";
const PENDING_APP_ALERT_KEY = "pending_app_alert";
const STYLE_TO_COLOR = {
  success: "success",
  error: "danger",
  danger: "danger",
  warning: "warning",
  info: "info",
};

export const queueAppAlert = (message, style = "info", timeout = 5000) => {
  if (!message) {
    return;
  }

  sessionStorage.setItem(
    PENDING_APP_ALERT_KEY,
    JSON.stringify({
      message: String(message),
      style,
      timeout,
    })
  );
};

export const showAppAlert = (message, style = "info", timeout = 5000) => {
  if (!message) {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(APP_ALERT_EVENT, {
      detail: {
        message: String(message),
        style,
        timeout,
      },
    })
  );
};

const AppAlerts = () => {
  const [alerts, setAlerts] = useState([]);

  const dismissAlert = useCallback((id) => {
    setAlerts((prev) => prev.filter((item) => item.id !== id));
  }, []);

  useEffect(() => {
    const onAlert = (event) => {
      const detail = event?.detail || {};
      const id = `${Date.now()}-${Math.random()}`;
      const timeout = Number(detail.timeout) || 5000;

      setAlerts((prev) => [
        ...prev,
        {
          id,
          message: detail.message,
          style: detail.style || "info",
          color: STYLE_TO_COLOR[String(detail.style || "info").toLowerCase()] || "info",
        },
      ]);

      if (timeout > 0) {
        setTimeout(() => dismissAlert(id), timeout);
      }
    };

    window.addEventListener(APP_ALERT_EVENT, onAlert);

    const pendingAlertRaw = sessionStorage.getItem(PENDING_APP_ALERT_KEY);
    if (pendingAlertRaw) {
      sessionStorage.removeItem(PENDING_APP_ALERT_KEY);
      try {
        const pendingAlert = JSON.parse(pendingAlertRaw);
        onAlert({ detail: pendingAlert });
      } catch (error) {
        // Ignoramos valores corruptos para no romper el render.
      }
    }

    return () => window.removeEventListener(APP_ALERT_EVENT, onAlert);
  }, [dismissAlert]);

  if (alerts.length === 0) {
    return null;
  }

  return (
    <div style={{ position: "fixed", top: 16, right: 16, zIndex: 1080, maxWidth: 460 }}>
      {alerts.map((item) => (
        <Alert
          key={item.id}
          color={item.color}
          toggle={() => dismissAlert(item.id)}
          className="mb-2"
        >
          {item.message}
        </Alert>
      ))}
    </div>
  );
};

export default AppAlerts;
